import _ from "lodash";

export default {
    methods: {
        __(t, opt, allowHtml) {
            let result = _.get(this.$store.translations, t, t);
            if (opt && opt.length > 0) {
                for (let index in opt) {
                    result = result.replace("{" + index + "}", opt[index]);
                }
            }
            return allowHtml ? result : result.replace(/<(?:.|\n)*?>/gm, '');
        },
    },
};